export default "<smart-navbar></smart-navbar>\n<router-outlet></router-outlet>\n<smart-footer *ngIf=\"removeFooter()\"></smart-footer>\n";